import { TableBody, TableCell, TableHead, TableRow } from "@mui/material"

// others
import { Fee_Type_Headers } from "../../../constants"
import { FeeTypeListingProps } from "../../../interfaceTypes/props"

// components
import { CustomPagination } from "../../common/CustomPagination"
import { CustomTableCell } from "../../common/CustomTableCell"
import { StickyTable } from "../../common/StickyTable"
import { TableSkeleton } from "../../skeletons/TableSkeleton"
import FeeTypeMenu from "./FeeTypeMenu"

const FeeTypeListing = ({ feeTypes, loading , refetch} : FeeTypeListingProps) => {
  return (
    <StickyTable pagination={<CustomPagination loading={loading} />} height="370px">
      <TableHead>
        <TableRow hover>
          {Fee_Type_Headers.map((columnName, index) => 
            <TableCell 
              key={index} 
              component="th" 
              align={'left'} 
              width={index === Fee_Type_Headers.length - 1 ? '100px' : 'auto'} 
            >
              {columnName}
            </TableCell>
          )}
        </TableRow>
      </TableHead>
          
      { loading ?         
        <TableSkeleton noOfRows={7} noOfCols={Fee_Type_Headers.length} />
        : <TableBody>
          {feeTypes?.map((fee) => {
            const { id, feeType } = fee || {}

            return (
              <TableRow key={id} hover>
                <CustomTableCell value={feeType} maxWidth="376px" />
              
              
                <TableCell>
                  <FeeTypeMenu fee={fee} refetch={refetch} />
                </TableCell>
              </TableRow>
            )
          })}     
      </TableBody>     
      } 
    </StickyTable>
  )
}

export default FeeTypeListing